export const getMunicipalityExportItems = (exports, municipality) => {
  const commandBarItems = exports
    .filter(
      (item) =>
        item.municipalities.includes('all') ||
        item.municipalities.includes(municipality),
    )
    .map((item) => item.commandBarItem);

  const disableSubmenu = commandBarItems.every((item) => item.disabled);

  return {
    disableSubmenu,
    commandBarItems,
  };
};
